/**
 * This module just re-exports Velocity from velocity-animate.
 * velocity-animate is not compatible on node.
 * This module was created so that it can be replaced by webpack on the server side.
 */
import Velocity from 'velocity-animate';

export default Velocity;
